const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div id="proto-contact-a">
  `);
                this.echo(this.include(context, this.source, this.loadTemplate(`a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`, `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`, 2, 21), undefined, true, false, 2));
                this.echo(`
  <div class="proto-moar-layout">
    <div class="proto-moar-layout__body">
      <div class="proto-moar-layout__inner o-rhythm o-rhythm--lavish-headings">
        `);
                this.echo(this.include(context, this.source, this.loadTemplate(`a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`, `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`, 56, 22), new Map([[`tag_name`, `h2`], [`level`, 1], [`content`, `Not sure how to start?`]]), false, false, 56));
                this.echo(`        `);
                context.proxy[`email_content`] = (() => {let tmp = `Hi there,

  My name is [Firstname Lastname], I’m a [role] at [organization].

  I’m reaching out to discuss [project, question, challenge]. [Additional details, if any.]

  Our budget for this effort is [budget, range, etc.] and we’re interested in wrapping up in [timeframe].

  I’m available to chat [potential meeting times], let me know if any of those work for you.

  Have a great day!

  [Firstname Lastname]`; return tmp === '' ? '' : new this.Markup(tmp, this.env.getCharset());})();
                this.echo(`        <div class="proto-bestarea">
          `);
                this.echo(this.include(context, this.source, `@cloudfour/components/input/input.twig`, new Map([[`type`, `textarea`], [`value`, (context.has(`email_content`) ? context.get(`email_content`) : null)], [`class`, `c-input--elastic js-elastic-textarea`]]), false, false, 81));
                this.echo(`          `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`label`, `Copy`], [`content_start_icon`, `copy`]]), false, false, 86));
                this.echo(`        </div>
        `);
                this.echo(`      </div>
    </div>
    <div class="proto-moar-layout__sidebar">
      <div class="proto-moar-layout__inner o-rhythm o-rhythm--generous-headings">
        `);
                this.echo(this.include(context, this.source, this.loadTemplate(`a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`, `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`, 122, 23), new Map([[`tag_name`, `h2`], [`level`, 1], [`content`, `Resources`]]), false, false, 122));
                this.echo(`        <ul class="o-list o-rhythm">
          <li>
            <a class="proto-dl" href="#">
              `);
                this.echo(`              <img class="proto-dl__type" src="/media/drive-slides.svg" alt="" width="48" height="48">
              <b class="proto-dl__title">Capabilities Deck</b>
              <span class="proto-dl__info">Google Slides</span>
            </a>
          </li>
          <li>
            <a class="proto-dl" href="#">
              `);
                this.echo(`              <img class="proto-dl__type" src="/media/word.svg" alt="" width="48" height="48">
              <b class="proto-dl__title">MSA Template</b>
              <span class="proto-dl__info">Microsoft Word (376&nbsp;KB)</span>
            </a>
          </li>
        </ul>
        `);
                this.echo(`      </div>
    </div>
  </div>
</div>
`);
            }

            getTemplateName() {
                return `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`, ``);
            }
        }],
        [21, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/cloud-cover/cloud-cover.twig`, `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`, 2);

                this.blocks = new Map([
                    ['heading', [this, 'block_heading']],
                    ['content', [this, 'block_content']],
                    ['scene', [this, 'block_scene']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/cloud-cover/cloud-cover.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_heading(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      `);
                this.echo(this.include(context, this.source, this.loadTemplate(`a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`, `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`, 4, 19), new Map([[`level`,  -2]]), false, false, 4));
                this.echo(`    `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      <p>
        We’d love to chat about your project, answer your questions or show off what our team can do.
        `);
                this.echo(`      </p>
      `);
                this.echo(this.include(context, this.source, this.loadTemplate(`a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`, `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`, 18, 20), new Map([[`grow`, true]]), false, false, 18));
                this.echo(`    `);
            }

            block_scene(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      <svg class="c-cloud-cover__scene-object" viewBox="-10 -5 120 120">
        <line x1="24.93" y1="74.01" x2="47.54" y2="74.01" fill="none" stroke="#738da0" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/>
        <path d="M94.18,36.72c0-.16,.01-.32,.02-.47,0-.24,.02-.47,.03-.71,0-.05,0-.1,0-.14,0-.03,0-.06,0-.08,0-.11,0-.21,0-.32,0-.29-.01-.58-.02-.87,0-.14-.02-.28-.03-.43-.02-.3-.04-.61-.07-.91,0-.09-.02-.18-.03-.27-1.31-11.62-10.63-20.93-22.48-22.71-1.3-.19-2.59-.31-3.86-.36-.02,0-.03,0-.04,0-.38-.01-.76-.02-1.14-.03-.09,0-.18,0-.28,0-.12,0-.23,0-.35,0-.26,0-.52,0-.78,.02-.21,0-.42,.02-.62,.03-.35,.02-.69,.04-1.03,.07-.05,0-.09,0-.14,.01-11.76,1.06-21.32,8.33-24.11,19.14-.6,2.11-.93,4.33-.93,6.62,0,12.59,9.7,23.08,22.56,25.41v.04c1.27,.21,2.58,.35,3.9,.41,.03,0,.05,0,.08,0,.34,.01,.68,.02,1.02,.02,.13,0,.26,0,.4,0,.02,0,.04,0,.06,0,.03,0,.06,0,.09,0,.34,0,.67-.02,1-.03,.1,0,.2,0,.31,0,3.62-.16,7.05-.9,10.17-2.14,1.25,.86,3.27,1.79,6.34,2.07,2.53,.23,4.37,.03,5.66-.29,.95-.24,1.01-1.57,.09-1.9-1.67-.61-3.89-1.68-5.68-3.46,5.72-4.31,9.47-10.83,9.87-18.73" fill="#3d84f5"/>
        `);
                this.echo(`        <path d="M50.24,27.18H16.62c-1.1,0-2,.9-2,2v58c0,1.1,.9,2,2,2H62.62c1.1,0,2-.9,2-2V41.55c0-.53-.21-1.04-.59-1.42l-12.37-12.37c-.38-.38-.88-.59-1.41-.59" fill="#fff"/>
        <path d="M53.01,40.74h11.03c.22,0,.33-.27,.18-.43l-12.78-12.78c-.16-.16-.43-.05-.43,.18v11.03c0,1.11,.89,2,2,2" fill="#c0cfd8"/>
        <line x1="24.95" y1="46.09" x2="55.42" y2="46.09" fill="none" stroke="#c0cfd8" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/>
        <line x1="24.95" y1="53.09" x2="55.42" y2="53.09" fill="none" stroke="#c0cfd8" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/>
        <line x1="24.95" y1="60.01" x2="55.42" y2="60.01" fill="none" stroke="#c0cfd8" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/>
        <line x1="24.95" y1="67.01" x2="55.42" y2="67.01" fill="none" stroke="#c0cfd8" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/>
        <line x1="24.93" y1="74.01" x2="47.54" y2="74.01" fill="none" stroke="#c0cfd8" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/>
        <path d="M30.25,46.09c0-7.18-5.82-13-13-13s-13,5.82-13,13,5.82,13,13,13,13-5.82,13-13" fill="#71f4ae"/>
        <polyline points="11.25 46.09 15.06 50.59 23.25 41.59" fill="none" stroke="#105c52" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
      </svg>
    `);
            }

            getTemplateName() {
                return `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`, ``);
            }
        }],
        [19, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/heading/heading.twig`, `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`, 4);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/heading/heading.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          `);
                this.echo(`          Hire us
        `);
            }

            getTemplateName() {
                return `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`, ``);
            }
        }],
        [20, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/button-group/button-group.twig`, `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`, 18);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/button-group/button-group.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`label`, `Email us`], [`content_start_icon`, `envelope`], [`href`, `#`]]), false, false, 22));
                this.echo(`          `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`label`, `+1 (503) 290-1090`], [`href`, `#`], [`class`, `c-button--secondary`]]), false, false, 27));
                this.echo(`        `);
            }

            getTemplateName() {
                return `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`, ``);
            }
        }],
        [22, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/heading/heading.twig`, `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`, 56);

                this.blocks = new Map([
                    ['subheading', [this, 'block_subheading']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/heading/heading.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_subheading(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            Here’s an email template you can modify as you see fit!
          `);
            }

            getTemplateName() {
                return `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`, ``);
            }
        }],
        [23, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/heading/heading.twig`, `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`, 122);

                this.blocks = new Map([
                    ['subheading', [this, 'block_subheading']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/heading/heading.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_subheading(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            Handy docs and downloads
          `);
            }

            getTemplateName() {
                return `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59');

let template = env.loadTemplate('a5d9d7e707be201219a2c62c84e0332b4510ddc6d0e38b3ca5e1b08892996e59');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/prototypes/contact/contact-a.twig", args: context }
     );
     return rendered;;
};